import { Box, Flex } from '@chakra-ui/react';

import { ViewStar } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

type HistoryItem = {
  id: string;
  type: 'performance' | 'compensation';
  title: string;
  value: string;
  year: number;
};

const historyData: HistoryItem[] = [
  {
    id: '1',
    type: 'performance',
    title: 'Performance review 2025',
    value: 'Exceeds expectations',
    year: 2025,
  },
  {
    id: '2',
    type: 'compensation',
    title: 'Compensation cycle 2024',
    value: '$13/hr to $14/hr (7.6% increase)',
    year: 2024,
  },
  {
    id: '3',
    type: 'performance',
    title: 'Performance review 2024',
    value: 'Meets expectations',
    year: 2024,
  },
  {
    id: '4',
    type: 'compensation',
    title: 'Compensation cycle 2023',
    value: '$12/hr to $13/hr (8.3% increase)',
    year: 2023,
  },
  {
    id: '5',
    type: 'performance',
    title: 'Performance review 2023',
    value: 'Meets expectations',
    year: 2023,
  },
];

// Helper function to determine the color of the performance star based on the value
const getPerformanceStarColor = (performanceValue: string): { color: string; bg: string } => {
  const value = performanceValue.toLowerCase();

  if (value.includes('exceeds expectations')) return { color: 'functional.1A5724', bg: '#E1F7E2' };
  if (value.includes('meets expectations')) return { color: 'functional.AF5C20', bg: 'functional.FFE7C5' };

  return { color: 'transparent', bg: 'text.g2' };
};

const TimelineDot = () => <Box w="12px" h="12px" bg="icon.g3" borderRadius="50%" position="relative" zIndex={1} />;

// Renders a single history item
const HistoryItemComponent = ({ item, isLast }: { item: HistoryItem; isLast: boolean }) => (
  <Flex position="relative" gap="12px">
    {/* Timeline dot container with connecting line */}
    <Box position="relative" pt="2px">
      <TimelineDot />
      {!isLast && <Box position="absolute" left="4px" top="12px" w="4px" h="100%" bg="timeline.CFD7DF" zIndex={0} />}
    </Box>

    <Flex flexDir="column" gap="4px" flex={1} pb={isLast ? 0 : '16px'}>
      <Flex alignItems="center" gap="8px">
        <Flex alignItems="center" gap="2px" w="200px">
          <TextBodyMedium color="text.g2" breakWords>
            {item.title}
          </TextBodyMedium>
          <TextBodyMedium color="text.g2">:</TextBodyMedium>
        </Flex>
        <Flex alignItems="center" gap="6px">
          {item.type === 'performance' && (
            <Flex
              h="20px"
              w="20px"
              align="center"
              justify="center"
              bg={getPerformanceStarColor(item.value).bg}
              borderRadius="50%"
            >
              <ViewStar boxSize="12px" color={getPerformanceStarColor(item.value).color} />
            </Flex>
          )}
          <TextBodyMedium>{item.value}</TextBodyMedium>
        </Flex>
      </Flex>
    </Flex>
  </Flex>
);

export const CompensationHistory = () => (
  <Flex flexDir="column" bg="white" p="12px" borderRadius="8px" gap="12px">
    <Flex pb="8px" borderBottom="1px solid" borderColor="#E7E7E7">
      <TextBodyMedium bold>History</TextBodyMedium>
    </Flex>

    {/* Timeline items */}
    <Flex flexDir="column" py="8px">
      {historyData.map((item, index) => (
        <HistoryItemComponent key={item.id} item={item} isLast={index === historyData.length - 1} />
      ))}
    </Flex>
  </Flex>
);
